import React from 'react'
import PropTypes from 'prop-types'

import { MessageBox } from 'mailup-web-components'

const ErrorFeedback = ({ error, severity }) => {
  return (
    <MessageBox variant={severity}>
      <span>{error}</span>
    </MessageBox>
  )
}

ErrorFeedback.propTypes = {
  error: PropTypes.oneOf([PropTypes.node, PropTypes.string]).isRequired,
  severity: PropTypes.string.isRequired
}

export default ErrorFeedback
